// React
import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// Utils
import ScrollToTop from "./common/router/ScrollToTop";

// Snackbar
import { SnackbarProvider } from "notistack";

//Context
import { PlatformProvider } from "./common/context/PlatformContext";
import { AppProvider } from "./common/context/AppContext";
import { ThemeProvider } from "@mui/material/styles";

// Theme
import theme from "./common/utils/theme";

// Routes
import AppRoutes from "./Routes";

// Package
import packageJson from "../package.json";

const App = () => {
    return (
        <ThemeProvider theme={theme}>
            <BrowserRouter basename={packageJson.homepage}>
                <HelmetProvider>
                    <SnackbarProvider maxSnack={3}>
                        <AppProvider>
                            <PlatformProvider>
                                <ScrollToTop />
                                <AppRoutes />
                            </PlatformProvider>
                        </AppProvider>
                    </SnackbarProvider>
                </HelmetProvider>
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default App;
